// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tr_wrapper__2CUN5","clickable":"Tr_clickable__39l4G","checkbox":"Tr_checkbox__iQgfe"};